import {
  mapTo,
  switchMap,
  withLatestFrom,
  filter,
  switchMapTo,
  map,
  take,
  catchError
} from 'rxjs/operators'
import { of, combineLatest, forkJoin } from 'rxjs'
import { ofType } from 'redux-observable'
import Actions from '../actions'
import { getPayload } from '../utils/rxUtils'
import { clinicTypes } from '../consts'
import { DEFAULT_MESSAGE_DURATION } from '../consts/appConsts'
import { isFamilyPlanActive } from '../utils/familyUtils'
import { getJSON } from '../utils/fetchUtils'
import {
  filterCanInviteToMyCall,
  filterActiveMembers,
  filterCanCreateVisitBehalf
} from '../utils/familyPermissionsUtils'
import {
  isNeedToAskMyPharmacyUpdate,
  buildTimeWindowsUrl,
  isSelectedTimeWindowStillAvailable
} from '../utils/appointmentsUtils'
import { isReferredFirstTime } from '../utils/getCareUtils'
import { isInClinic, shouldDisplayInitClinic } from '../utils/clinicsUtils'
import {
  isDmServiceAvailable,
  isHtnServiceAvailable,
  isMhServiceAvailable
} from '../utils/clinicsUtils'
import $t from '../i18n'

export const startHtnBot = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.HTN_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(
      state =>
        isHtnServiceAvailable(state) && !isInClinic(state, clinicTypes.HTN)
    ),
    mapTo(Actions.createAction(Actions.HTN_BOT_STARTED))
  )

export const startFuHtnBot = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.HTN_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(
      state =>
        isHtnServiceAvailable(state) && isInClinic(state, clinicTypes.HTN)
    ),
    mapTo(Actions.createAction(Actions.OPEN_HTN_FOLLOW_UP_BOT_SCREEN))
  )

export const startFuDmBot = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.DIABETES_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(
      state =>
        isDmServiceAvailable(state) && isInClinic(state, clinicTypes.DIABETES)
    ),
    mapTo(Actions.createAction(Actions.OPEN_DM_FOLLOW_UP_BOT_SCREEN))
  )

export const startDmBot = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.DIABETES_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(
      state =>
        isDmServiceAvailable(state) && !isInClinic(state, clinicTypes.DIABETES)
    ),
    mapTo(Actions.createAction(Actions.DIABETES_BOT_STARTED))
  )

export const startMhBot = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.MENTALHEALTH_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(state => isMhServiceAvailable(state)),
    mapTo(Actions.createAction(Actions.MENTALHEALTH_BOT_STARTED))
  )

export const startHtnBotFailed = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.HTN_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(state => !isHtnServiceAvailable(state)),
    mapTo(
      Actions.createAction(Actions.BOT_ABORTED, { clinic: clinicTypes.HTN })
    )
  )

export const startDmBotFailed = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.DIABETES_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(state => !isDmServiceAvailable(state)),
    mapTo(
      Actions.createAction(Actions.BOT_ABORTED, {
        clinic: clinicTypes.DIABETES
      })
    )
  )

export const startMhBotFailed = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.MENTALHEALTH_BOT_INITED),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(state => !isMhServiceAvailable(state)),
    mapTo(
      Actions.createAction(Actions.BOT_ABORTED, { clinic: clinicTypes.MENTAL })
    )
  )

export const startMhHmoBotFailed = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.HMO_BOT_STARTED),
    filter(payload => payload?.isMentalHealth),
    withLatestFrom(state$),
    map(([_, state]) => state),
    filter(state => !isMhServiceAvailable(state)),
    mapTo(
      Actions.createAction(Actions.BOT_ABORTED, { clinic: clinicTypes.MENTAL })
    )
  )

export const requestTimeWindow = (action$, state$) => {
  return action$.pipe(
    ofType(Actions.PAYMENT_FLOW_CANCELLED, Actions.SHOW_ID_UPLOADED_REQUESTED),
    withLatestFrom(state$),
    mapTo(Actions.createAction(Actions.APPOINTMENT_TIMEWINDOWS_REQUESTED))
  )
}

export const clearDesignatedPkOnDoctorSelected = action$ =>
  action$.pipe(
    ofType(Actions.DOCTOR_SELECTED),
    filter(action => action.payload?.designated === false),
    mapTo(Actions.createAction(Actions.CLEARED_APPOINTMENT_DESIGNATED_PK))
  )

// export const inviteOtherMemberToCall = (actions$, state$) => {
//   return actions$.pipe(
//     getPayload(Actions.INVITE_OTHER_FAMILY_MEMBER_IF_NEEDED),
//     withLatestFrom(state$),
//     filter(([next, state]) => isNeedToInviteOtherMemberOptions(state)),
//     switchMap(([next, state]) => {
//       return of(
//         Actions.createAction(Actions.SHOW_INVITE_TO_CALL_FAMILY_OPTIONS, {
//           next,
//           member: state?.account?.members
//         })
//       )
//     })
//   )
// }

// export const dontInviteOtherMemberToCall = (actions$, state$) => {
//   return actions$.pipe(
//     getPayload(Actions.INVITE_OTHER_FAMILY_MEMBER_IF_NEEDED),
//     withLatestFrom(state$),
//     filter(([next, state]) => !isNeedToInviteOtherMemberOptions(state)),
//     switchMap(([{ next }, _]) => of(next))
//   )
// }

// export const requestDesignatedTimeWindows = (action$, state$) => {
//   return action$.pipe(
//     getPayload(Actions.DOCTOR_SELECTED),
//     filter(payload => payload?.designated),
//     withLatestFrom(state$),
//     switchMap(([_, state]) => {
//       const designatedPk = state.account?.personalDoctor?.personalDoctor?.id
//       const next = Actions.createAction(
//         Actions.APPOINTMENT_TIMEWINDOWS_REQUESTED,
//         { designatedPk }
//       )
//       return of(
//         Actions.createAction(Actions.INVITE_OTHER_FAMILY_MEMBER_IF_NEEDED, {
//           next,
//         })
//       )
//     })
//   )
// }

// export const requestUploadId = (action$, state$) => {
//   return action$.pipe(
//     getPayload(Actions.DOCTOR_SELECTED),
//     filter(payload => !payload?.designated),
//     withLatestFrom(state$),
//     switchMap(([_, state]) => {
//       const next = Actions.createAction(
//         Actions.APPOINTMENT_TIMEWINDOWS_REQUESTED
//       )
//       return of(
//         Actions.createAction(Actions.INVITE_OTHER_FAMILY_MEMBER_IF_NEEDED, {
//           next
//         })
//       )
//     })
//   )
// }

export const triggerPayment = (actions$, state$) =>
  actions$.pipe(
    getPayload(Actions.APPOINTMENT_TIME_SELECTED),
    withLatestFrom(state$),
    switchMap(([{ option }, state]) => {
      if (option === 'earliest') {
        return of(
          Actions.createAction(Actions.PAYMENT_FLOW_TRIGGERED),
          Actions.createAction(Actions.WIZARD_ENDED)
        )
      }

      const { url, context } = buildTimeWindowsUrl(state)

      return getJSON(url).pipe(
        switchMap(result => {
          const selectedTimeStillAvailable = isSelectedTimeWindowStillAvailable(
            result,
            option
          )

          const refreshAction = context.isDesignatedFlow
            ? Actions.createAction(
                Actions.APPOINTMENT_DESIGNATED_TIMEWINDOWS_RECEIVED,
                {
                  timeWindows: result,
                  designatedPk: context.designatedPk
                }
              )
            : Actions.createAction(
                Actions.APPOINTMENT_TIMEWINDOWS_RECEIVED,
                result
              )

          if (selectedTimeStillAvailable) {
            return of(
              Actions.createAction(Actions.PAYMENT_FLOW_TRIGGERED),
              Actions.createAction(Actions.WIZARD_ENDED)
            )
          }

          return of(
            refreshAction,
            Actions.createAction(Actions.OPERATION_FAILED, {
              error: {
                body: {
                  message: $t('errors.selectedTimeNoLongerAvailable')
                }
              }
            })
          )
        }),
        catchError(error =>
          of(Actions.createAction(Actions.OPERATION_FAILED, { error }))
        )
      )
    })
  )

const needsToChooseADoctor = state =>
  !!state.account.personalDoctor?.personalDoctorSelected

const isNeedToInviteOtherMemberOptions = state => {
  // TODO!! ????
  return false
  const members = state.account?.members
  const membersICanInvite = members?.find(member =>
    filterCanInviteToMyCall(member)
  )
  const appointmentSelectedMember = state?.account?.selectedMember
  if (appointmentSelectedMember) {
    const appointmentIsForMe =
      appointmentSelectedMember.id === state.profile.userDetails.id
    return (
      (state?.app.features['allow_family_for_all'] ||
        isFamilyPlanActive(state)) &&
      membersICanInvite &&
      appointmentIsForMe
    )
  }
  return (
    (state?.app.features['allow_family_for_all'] ||
      isFamilyPlanActive(state)) &&
    membersICanInvite
  )
}

export const autoSelectFamilyViewOnGetCare = actions$ =>
  actions$.pipe(
    getPayload(
      Actions.HTN_BOT_INITED,
      Actions.DIABETES_BOT_INITED,
      Actions.MENTALHEALTH_BOT_INITED,
      Actions.PRIMARY_CLINIC_CLICKED
    ),
    switchMap(() =>
      of(
        Actions.createAction(Actions.CHOOSE_FAMILY_MEMBER, {
          member: null
        })
      )
    )
  )

export const getFamilyMembers = (actions$, state$) =>
  actions$.pipe(
    getPayload(Actions.SHOW_FAMILY_MEMBERS_REQUESTED),
    withLatestFrom(state$),
    switchMap(([next, state]) => {
      const membersICanCreateBehalf = state?.account?.members
        .filter(member => filterActiveMembers(member))
        .filter(member => filterCanCreateVisitBehalf(member))

      return of(
        Actions.createAction(Actions.SHOW_FAMILY_MEMBERS_RECEIVED, {
          next,
          members: membersICanCreateBehalf
        })
      )
    })
  )

export const getFamilyMembersForInvite = (actions$, state$) =>
  actions$.pipe(
    getPayload(Actions.SHOW_INVITE_FAMILY_MEMBER_CHOSEN),
    withLatestFrom(state$),
    switchMap(([next, state]) => {
      const membersICanInvite = state?.account?.members
        .filter(member => filterActiveMembers(member))
        .filter(member => filterCanInviteToMyCall(member))

      return of(
        Actions.createAction(Actions.SHOW_INVITE_FAMILY_LIST, {
          next,
          members: membersICanInvite
        })
      )
    })
  )

export const appointmentCreated = actions$ =>
  actions$.pipe(
    getPayload(Actions.CREATE_APPOINTMENT_RECEIVED),
    switchMap(payload =>
      of(
        Actions.createAction(Actions.APPOINTMENT_APPROVAL_ENDED, {
          appointments: [payload]
        })
      )
    )
  )

export const updatePharmacyForMember = (action$, state$) =>
  action$.pipe(
    getPayload(Actions.UPDATE_MY_PHARMACY_PRESSED_FOR_OTHER_MEMBER),
    withLatestFrom(state$),
    filter(([_, state]) => !isNeedToAskMyPharmacyUpdate(state)),
    switchMap(([_, state]) => {
      return of(
        Actions.createAction(Actions.UPDATE_MY_PHARMACY_REQUESTED, {
          patientId: state?.account?.selectedMember?.id,
          pharmacy: state?.userDetails?.pharmacy
        })
      )
    })
  )

export const referredFirstTime = (actions$, state$) =>
  actions$.pipe(
    getPayload(Actions.PENDING_APPOINTMENT_FOUND),
    withLatestFrom(state$),
    filter(([pendingAppointment, state]) =>
      isReferredFirstTime(state, pendingAppointment)
    ),
    switchMap(([pendingAppointment, _]) => {
      return of(
        Actions.createAction(
          Actions.PENDING_APPOINTMENT_REFERRED_CREATED,
          pendingAppointment
        )
      )
    })
  )

export const initClinicAfterLogin = (action$, state$) => {
  const profile$ = action$.pipe(getPayload(Actions.USER_PROFILE_RECEIVED))

  const reset$ = action$.pipe(ofType(Actions.USER_LOGGED_IN_SUCCSESSFULY))

  return combineLatest([profile$, reset$]).pipe(
    withLatestFrom(state$),
    filter(
      ([__, { profile }]) =>
        profile?.userDetails &&
        shouldDisplayInitClinic(
          profile?.userDetails?.payments?.user_plan_clinic
        )
    ),
    map(([__, { profile }]) =>
      Actions.createAction(
        Actions.GET_CLINIC_INIT,
        profile?.userDetails?.payments?.user_plan_clinic
      )
    )
  )
}

export const initClinicAfterPayment = actions$ => {
  const profile$ = actions$.pipe(getPayload(Actions.USER_PROFILE_RECEIVED))

  const paymentSuccess$ = actions$.pipe(getPayload(Actions.PAYMENT_SUCCESS))

  const zipped$ = forkJoin(profile$, paymentSuccess$)

  return zipped$.pipe(
    map(([payload, _]) => payload),
    filter(({ profile }) =>
      shouldDisplayInitClinic(profile?.payments?.user_plan_clinic)
    ),
    switchMap(({ profile }) =>
      of(
        Actions.createAction(
          Actions.GET_CLINIC_INIT,
          profile?.payments?.user_plan_clinic
        )
      )
    ),
    take(1)
  )
}

export const startChatWithClinicInit = (action$, state$) => {
  const clinicsData$ = action$.pipe(ofType(Actions.CLINICS_DATA_RECEIVED))

  const clinicInit$ = action$.pipe(ofType(Actions.GET_CLINIC_INIT))

  const zipped$ = forkJoin(clinicsData$, clinicInit$)

  return zipped$.pipe(
    map(([_, clinic]) => clinic),
    withLatestFrom(state$),
    // filter for initial clinics only
    filter(([{ payload }, state]) => !isInClinic(state, payload)),
    map(([{ payload }, _]) => {
      // payload is clinic
      return Actions.createAction(Actions.ASK_TO_START_CLINIC, payload)
    })
  )
}

export const popMessageFileSuccess = action$ =>
  action$.pipe(
    getPayload(Actions.UPLOAD_FILE_RECEIVED),
    mapTo(
      Actions.createAction(Actions.MESSAGE_DISPLAYED, {
        content: $t('dialogs.uploadPatientFile.success'),
        type: 'success'
      })
    )
  )

export const filterDuplicateMessages = (action$, state$) =>
  action$.pipe(
    ofType(Actions.MESSAGE_DISPLAYED),
    withLatestFrom(state$),
    filter(([action, state]) => {
      const messageConfig = state.app?.messageConfig
      const newMessage = action.payload

      const isSameMessage =
        messageConfig?.content === newMessage?.content &&
        messageConfig?.type === newMessage?.type

      if (isSameMessage && messageConfig?.timestamp) {
        const duration = messageConfig?.duration || DEFAULT_MESSAGE_DURATION
        const timeSinceLastMessage = Date.now() - messageConfig.timestamp
        return timeSinceLastMessage >= duration * 1000
      }

      return true
    }),
    map(([action]) =>
      Actions.createAction(Actions.MESSAGE_DISPLAY_APPROVED, action.payload)
    )
  )
